"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mixpanelTimeEvent = exports.mixpanelTrack = exports.mixpanelReset = exports.mixpanelIdentify = exports.mixpanelInit = void 0;
var mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
var mixpanelVerify = process.env.CB_USE_MIXPANEL == 'true';
var mixpanelInit = function () {
    mixpanelVerify &&
        mixpanel_browser_1.default.init(process.env.CB_MIXPANEL_TOKEN || '', {
            debug: true,
            track_pageview: false,
            persistence: 'localStorage'
        });
};
exports.mixpanelInit = mixpanelInit;
var mixpanelIdentify = function (props) {
    var id = props.id, tenant = props.tenant, locale = props.locale, role = props.role, isLean = props.isLean;
    if (mixpanelVerify) {
        mixpanel_browser_1.default.identify(id);
        mixpanel_browser_1.default.register({
            tenant: tenant,
            locale: locale,
            role: role,
            isLean: isLean
        });
    }
};
exports.mixpanelIdentify = mixpanelIdentify;
var mixpanelReset = function () {
    mixpanelVerify && mixpanel_browser_1.default.reset();
};
exports.mixpanelReset = mixpanelReset;
var mixpanelTrack = function (props) {
    var eventName = props.eventName, properties = props.properties, optionsOrCallback = props.optionsOrCallback, callback = props.callback;
    mixpanelVerify && mixpanel_browser_1.default.track(eventName, properties, optionsOrCallback, callback);
};
exports.mixpanelTrack = mixpanelTrack;
var mixpanelTimeEvent = function (endEvent) {
    mixpanelVerify && mixpanel_browser_1.default.time_event(endEvent);
};
exports.mixpanelTimeEvent = mixpanelTimeEvent;
